import React, { useState, useEffect } from "react";
import { BASE_URL } from "../utils/config";
import { getAuthHeaders } from "../utils/auth";
import "../styles/BookingsManagement.css";

const BookingsManagement = () => {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedBooking, setSelectedBooking] = useState(null);

  useEffect(() => {
    fetchBookings();
  }, []);

  const fetchBookings = async () => {
    try {
      const headers = getAuthHeaders(false);
      const res = await fetch(`${BASE_URL}/booking`, {
        headers,
      });

      if (res.ok) {
        const data = await res.json();
        if (data.success) {
          setBookings(data.data || []);
        } else {
          setError(data.message || "Failed to fetch bookings");
        }
      } else {
        setError("Failed to fetch bookings");
      }
    } catch (error) {
      setError("Error loading bookings");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  if (loading) {
    return (
      <div className="admin-loading">
        <div className="admin-loader"></div>
        <p>Loading bookings...</p>
      </div>
    );
  }

  return (
    <div className="bookings-management">
      <div className="bookings-header">
        <h3>All Bookings ({bookings.length})</h3>
        <button className="refresh-btn" onClick={fetchBookings}>
          <i className="ri-refresh-line"></i> Refresh
        </button>
      </div>

      {error && <div className="error-message">{error}</div>}

      {bookings.length === 0 ? (
        <div className="empty-state">
          <i className="ri-bookmark-line"></i>
          <h3>No Bookings Found</h3>
          <p>No tour bookings have been made yet.</p>
        </div>
      ) : (
        <div className="bookings-grid">
          {bookings.map((booking) => (
            <div key={booking._id} className="booking-card">
              <div className="booking-card-header">
                <h4>{booking.tourName || "Tour Booking"}</h4>
                <span className="booking-date">{formatDate(booking.createdAt)}</span>
              </div>
              <div className="booking-card-body">
                <div className="booking-info">
                  <div className="info-item">
                    <i className="ri-user-line"></i>
                    <span><strong>Name:</strong> {booking.fullName}</span>
                  </div>
                  <div className="info-item">
                    <i className="ri-mail-line"></i>
                    <span><strong>Email:</strong> {booking.userEmail || "N/A"}</span>
                  </div>
                  <div className="info-item">
                    <i className="ri-phone-line"></i>
                    <span><strong>Phone:</strong> {booking.phone}</span>
                  </div>
                  <div className="info-item">
                    <i className="ri-group-line"></i>
                    <span><strong>Group Size:</strong> {booking.groupSize} {booking.groupSize === 1 ? 'person' : 'people'}</span>
                  </div>
                  <div className="info-item">
                    <i className="ri-calendar-line"></i>
                    <span><strong>Booked For:</strong> {formatDate(booking.bookAt)}</span>
                  </div>
                </div>
              </div>
              <div className="booking-card-footer">
                <div className="contact-actions">
                  <a
                    href={`mailto:${booking.userEmail}`}
                    className="contact-btn email-btn"
                    title="Send Email"
                  >
                    <i className="ri-mail-line"></i>
                    <span>Email</span>
                  </a>
                  <button
                    className="contact-btn phone-btn"
                    title="Copy Phone Number"
                    onClick={() => {
                      navigator.clipboard.writeText(booking.phone);
                      alert("Phone number copied to clipboard!");
                    }}
                  >
                    <i className="ri-file-copy-line"></i>
                    <span>Copy</span>
                  </button>
                </div>
                <button
                  className="view-details-btn"
                  onClick={() => setSelectedBooking(booking)}
                >
                  View Details
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      {selectedBooking && (
        <div className="booking-modal" onClick={() => setSelectedBooking(null)}>
          <div className="booking-modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Booking Details</h3>
              <button className="close-btn" onClick={() => setSelectedBooking(null)}>
                <i className="ri-close-line"></i>
              </button>
            </div>
            <div className="modal-body">
              <div className="detail-row">
                <strong>Tour Name:</strong>
                <span>{selectedBooking.tourName}</span>
              </div>
              <div className="detail-row">
                <strong>Customer Name:</strong>
                <span>{selectedBooking.fullName}</span>
              </div>
              <div className="detail-row">
                <strong>Email:</strong>
                <span>{selectedBooking.userEmail || "N/A"}</span>
              </div>
              <div className="detail-row">
                <strong>Phone:</strong>
                <span>{selectedBooking.phone}</span>
              </div>
              <div className="detail-row">
                <strong>Group Size:</strong>
                <span>{selectedBooking.groupSize} {selectedBooking.groupSize === 1 ? 'person' : 'people'}</span>
              </div>
              <div className="detail-row">
                <strong>Booked For:</strong>
                <span>{formatDate(selectedBooking.bookAt)}</span>
              </div>
              <div className="detail-row">
                <strong>Booking Date:</strong>
                <span>{formatDate(selectedBooking.createdAt)}</span>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BookingsManagement;

